import { Token } from '../token.class.mjs';
export function normalizeIdentifier(identifier) {
    let name;
    return typeof identifier === 'string'
        ? identifier
        : identifier instanceof Token
            ? `Token<${identifier.name ?? 'UNSET_NAME'}>`
            : ((name = identifier?.name ?? identifier.prototype?.name) && `MaybeConstructable<${name}>`) ??
                '<UNKNOWN_IDENTIFIER>';
}
//# sourceMappingURL=normalize-identifier.util.mjs.map